<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ArrowLeft from '~/components/icons/ArrowLeft.vue';
import ChevronRightLg from '~/components/icons/ChevronRightLg.vue';

interface IBreadcrumb {
  title: string;
  href: string;
  disabled?: boolean;
}

const { breadcrumbs = [] } = defineProps<{
  breadcrumbs?: IBreadcrumb[];
}>();

const route = useRoute();
const router = useRouter();

const segmentTitleMap: Record<string, string> = {
  account: 'Account Settings',
  'personal-details': 'Personal Information',
  'account-settings': 'Login & Security',
};

const crumbs = computed((): IBreadcrumb[] => {
  if (breadcrumbs?.length) {
    return breadcrumbs;
  }

  const fullPath = route.fullPath;
  const params = fullPath.startsWith('/') ? fullPath.substring(1).split('/') : fullPath.split('/');
  const crumbs: any = [];
  let path = '';
  params.forEach((param) => {
    path = `${path}/${param}`;
    crumbs.push({
      title: segmentTitleMap[param] ?? param.replace(/-/g, ' '),
      to: path,
    });
  });
  return crumbs;
});

const redirectToParent = () => {
  const parentPath = route.path.split('/').slice(0, -1).join('/');
  if (parentPath) {
    router.push(parentPath);
  }
};
</script>

<template>
  <div class="d-flex gap-sm breadcrumbs">
    <ArrowLeft @click="redirectToParent" />
    <v-breadcrumbs :items="crumbs" class="pa-0">
      <template #title="{ item }">
        <p class="text-capitalize pa-0">{{ item.title }}</p>
      </template>
      <template #divider>
        <ChevronRightLg />
      </template>
    </v-breadcrumbs>
  </div>
</template>

<style lang="scss" scoped>
@use '~/assets/scss/_spacing.scss' as *;
@use '~/assets/scss/_variables.scss' as *;

:deep(.v-breadcrumbs-divider) {
  padding: 0;
  display: flex;
}

.breadcrumbs {
  overflow-x: auto;
  flex-wrap: nowrap;

  @media (max-width: $breakpoint-md) {
    flex-direction: column;
    gap: $spacing-lg !important;
  }

  ul {
    margin: 0 !important;
    flex-wrap: nowrap;
  }
}
</style>
